import { configureStore } from '@reduxjs/toolkit';
import navigatorSlice from '../pages/BusinessNavigatorPage/navigatorSlice';
import checklistSlice from '../pages/MyBusinessChecklistPage/checklistSlice';
import serviceSlice from '../pages/PrimeAccountServicesPage/serviceSlice';
import billingSlice from '../pages/BillingHistoryPage/billingSlice';
import mailSlice from '../pages/MailBoxPage/mailSlice';
import paymentSlice from '../pages/PaymentInfo/paymentSlice';
import legalTemplatesSlice from '../pages/LegalTemplates/legalTemplatesSlice';
export default configureStore({
    reducer: {
        navigator: navigatorSlice,
        checklist: checklistSlice,
        service: serviceSlice,
        mail: mailSlice,
        billing: billingSlice,
        payment: paymentSlice,
        legalTemplates: legalTemplatesSlice,
    },
});
